import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {ColorBar} from "..";
import {Code, Exhibit} from "timvir/blocks";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "ColorBar"
    }), "\n", _jsxs(_components.p, {
      children: ["A ", _jsx(_components.code, {
        children: "ColorBar"
      }), " is a horizontal arrangement of swatches."]
    }), "\n", _jsx(Exhibit, {
      children: _jsx(ColorBar, {
        values: ["#D6CCFF", "#C8BCF5", "#BAACEB", "#AC9CE1", "#9E8CD7", "#907DCD", "#826EC3", "#745FBA", "#6550B0", "#5642A6"]
      })
    }), "\n", _jsx(Exhibit, {
      children: _jsx(ColorBar, {
        values: ["#a0dbc2", "#60c19f", "#1a896b", "#0e6d54"]
      })
    }), "\n", _jsx(Code, {
      language: "jsx",
      caption: "Pass an array of color values to the component.",
      highlightedLines: [5],
      children: "import * as React from \"react\";\nimport { ColorBar } from \"timvir/blocks\";\n\nexport default function Sample() {\n  return <ColorBar values={[\"#97F3EB\", \"#78D5CC\", \"#58B8AE\", \"#369C91\", \"#008075\"]} />;\n}\n"
    }), "\n", _jsx(_components.p, {
      children: "The ColorBar works comfortably with as few as two colors and as many as 20"
    }), "\n", _jsx(Exhibit, {
      caption: "Two colors in a ColorBar",
      children: _jsx(ColorBar, {
        values: [{
          value: "#FFE4A0",
          name: "Yellow Submarine",
          ancestry: "Yellow 001"
        }, {
          value: "#A67908",
          name: "Yellow Spaceship",
          ancestry: "Yellow 999",
          contrastValue: "white"
        }]
      })
    }), "\n", _jsx(Exhibit, {
      caption: "20 colors in a ColorBar",
      children: _jsx(ColorBar, {
        values: ["#FFE4A0", "#FBDE98", "#F6D891", "#F2D28A", "#EDCC82", "#E8C77B", "#E4C173", "#DFBB6C", "#DBB565", "#D6B05D", "#D1AA56", "#CDA54F", "#C89F47", "#C39940", "#BE9438", "#BA8E30", "#B58928", "#B0841F", "#AB7E15", "#A67908"]
      })
    }), "\n", _jsx(_components.h2, {
      children: "Text Colors"
    }), "\n", _jsxs(_components.p, {
      children: ["These are the main text colors that are used in our website. We have a ", _jsx(_components.strong, {
        children: "textPrimary"
      }), " color for\nheadings and body text, ", _jsx(_components.strong, {
        children: "textSecondary"
      }), " for captions and meta lines, and a third (yet unamed)\ntext color for card descriptions."]
    }), "\n", _jsxs(_components.p, {
      children: ["All text colors are taken from the ", _jsx(_components.strong, {
        children: "Gray"
      }), " palette."]
    }), "\n", _jsx(Exhibit, {
      caption: "Text Colors",
      style: {
        margin: "10px 0 20px 0"
      },
      children: _jsx(ColorBar, {
        values: [{
          value: "rgba(0, 0, 13, 0.89)",
          name: "textPrimary",
          ancestry: "Gray 01",
          contrastValue: "white"
        }, {
          value: "rgba(0, 0, 13, 0.69)",
          name: "???? (unnamed)",
          ancestry: "Gray 03",
          contrastValue: "white"
        }, {
          value: "rgba(0, 0, 13, 0.49)",
          name: "textSecondary",
          ancestry: "Gray 05"
        }]
      })
    }), "\n", _jsx(Exhibit, {
      caption: "Gray Color Palette (00 – 09)",
      style: {
        margin: "-12px 0 20px 0"
      },
      children: _jsx(ColorBar, {
        values: [{
          value: "rgba(0, 0, 13, 0.99)",
          name: "Gray 00",
          contrastValue: "white"
        }, {
          value: "rgba(0, 0, 13, 0.89)",
          name: "Gray 01",
          contrastValue: "white"
        }, {
          value: "rgba(0, 0, 13, 0.79)",
          name: "Gray 02",
          contrastValue: "white"
        }, {
          value: "rgba(0, 0, 13, 0.69)",
          name: "Gray 03",
          contrastValue: "white"
        }, {
          value: "rgba(0, 0, 13, 0.59)",
          name: "Gray 04",
          contrastValue: "white"
        }, {
          value: "rgba(0, 0, 13, 0.49)",
          name: "Gray 05",
          contrastValue: "black"
        }, {
          value: "rgba(0, 0, 13, 0.39)",
          name: "Gray 06",
          contrastValue: "black"
        }, {
          value: "rgba(0, 0, 13, 0.29)",
          name: "Gray 07",
          contrastValue: "black"
        }, {
          value: "rgba(0, 0, 13, 0.19)",
          name: "Gray 08",
          contrastValue: "black"
        }, {
          value: "rgba(0, 0, 13, 0.09)",
          name: "Gray 09",
          contrastValue: "black"
        }]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Wrap a ", _jsx(_components.code, {
        children: "<ColorBar>"
      }), " in a ", _jsx(_components.code, {
        children: "<Exhibit>"
      }), " to add a caption to it. The caption can even include links!"]
    }), "\n", _jsx(Exhibit, {
      caption: _jsxs(_Fragment, {
        children: ["Source: ", _jsx(_components.a, {
          href: "https://hihayk.github.io/scale/#2/7/50/90/0/0/0/-0/1190D7/17/144/215",
          children: "hihayk.github.io/scale"
        })]
      }),
      children: _jsx(ColorBar, {
        values: ["#E7F4FB", "#C9E6F6", "#AAD7F1", "#8BC9EC", "#6DBBE6", "#4EADE1", "#309EDC", "#1190D7", "#0D6CA1", "#09486C"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
